import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_search.svg';
import Icon, { IconProps } from './icon';

const IconSearch = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconSearch;
